import customerApi from "@/api/customer";

const customerStore = {
  namespaced: true,
  state: {
    customerList: []
  },
  mutations: {
    setCustomerList(state, data) {
      state.customerList = data;
    }
  },
  actions: {
    listAll(ctx, data) {
      const searchCondition = {
        request: {
          pageIndex: 1,
          pageSize: 10000
        }
      };

      customerApi.pageQuery(searchCondition).then(res => {
        ctx.commit(
          "setCustomerList",
          res.items.map(item => ({
            label: item.name,
            value: item.customerId,
            type: item.type
          }))
        );
      });
    }
  }
};

export default customerStore;
